export type TSelectedLayerKeyboardAction = "duplicate" | "delete" | null;

type TKeyboardShortcutEvent = Pick<
  KeyboardEvent,
  "altKey" | "ctrlKey" | "key" | "metaKey" | "shiftKey"
>;

export const getSelectedLayerKeyboardAction = ({
  altKey,
  ctrlKey,
  key,
  metaKey,
  shiftKey,
}: TKeyboardShortcutEvent): TSelectedLayerKeyboardAction => {
  const isDuplicateShortcut =
    key.toLowerCase() === "c" && (metaKey || ctrlKey) && !shiftKey && !altKey;

  if (isDuplicateShortcut) return "duplicate";
  if (key === "Delete" || key === "Backspace") return "delete";
  return null;
};

export const isEditableKeyboardTarget = (element: Element | null): boolean => {
  if (!(element instanceof HTMLElement)) return false;

  return (
    element.tagName === "INPUT" ||
    element.tagName === "TEXTAREA" ||
    element.tagName === "SELECT" ||
    element.isContentEditable
  );
};
